import AddIcon from "@mui/icons-material/Add";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import TuneIcon from "@mui/icons-material/Tune";
import { Card, FormHelperText, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import payImg from "../../../assets/images/png/pay.png";
import viewImg from "../../../assets/images/png/view.png";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import Table from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import { default as CustomSelect } from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import {
  getClinicPaymentsByFilter,
  getClinicStocks,
  getServices,
  updatePayment,
} from "../../../redux/reducers/clinicSlice";
import { getPaymentMethods } from "../../../redux/reducers/paymentMethodSlice";
import { updateBillingItemsReturn } from "../../../redux/reducers/paymentSlice";
import { getCompliantSummaryByIdWoLoader } from "../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import {
  PaymentTypeList,
  RMVPaymentTypeList,
  RefundTypes,
  paymentInvoiceTypeList,
  paymentStatusList,
  paymentTypeList,
} from "../../../util/dropList";
import {
  getBorderColor,
  getPharmacyRecordBasedType,
  getRefundValues,
  getTaxAndSubTotalAndTotal,
  getTaxAndSubTotalAndTotalForTreatment,
  getTreatmentRecordBasedType,
  reorderList,
} from "../../../util/function";
import { RMVClinicId } from "../../../util/server";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import "./ClinicPayments.css";

const tableHeaders = [
  "petName",
  "vetName",
  "balanceDue",
  "payType",
  "paymentStatus",
  "trDate",
  "pay",
];

const initialValues = { amount: "", paymentMode: null };

const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const initSearch = {
  petName: "",
  userName: "",
  vetName: "",
  startDate: null,
  endDate: null,
};
const filterByList = [
  "Invoice Number",
  "Status",
  "Type",
  "Invoice Type",
  "Payment Mode",
  "Balance Due",
  "Person In Charge",
];
const dropFields = [
  "Status",
  "Type",
  "Invoice Type",
  "Payment Mode",
  "Person In Charge",
];

const Payments = ({ posPayId, setPosPayId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const contentToPrint = useRef(null);
  const [tablePayments, setTablePayments] = useState([]);
  const [payValues, setPayValues] = useState(initialValues);
  const [payErr, setPayErr] = useState({});
  const [searchText, setSearchText] = useState("");
  const [payModalVisible, setPayModalVisible] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const [selectMode, setSelectMode] = useState("all");
  const [selectedSource, setSelectedSource] = useState("all");
  const [modalData, setModalData] = useState(null);
  const [page, setPage] = useState(1);
  const [selectedBill, setSelectedBill] = useState(null);
  const [invModVisible, setInvModVisible] = useState(false);
  const [returnModVsble, setReturnModVsble] = useState(false);
  const [returnValue, setReturnValue] = useState({});
  const [listNotValid, setListNotValid] = useState(false);
  const [enabledPaymentTypes, setEnabledPaymentTypes] =
    useState(PaymentTypeList);
  const [totalBalanceDue, setTotalBalanceDue] = useState(0);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [filterValues, setFilterValues] = useState(initFilter);
  const {
    payments,
    hugePayments,
    details: clinicDet,
    clinicStocks: stocks,
    services,
    paymentsByFilter,
  } = useSelector((state) => state?.clinic);
  const lastSummary = useSelector((state) => state?.pet?.lastSummary?.data);
  const paymentMethod = useSelector((state) => state?.paymentMethod);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const itemsPerLoad = 10;
  const hugeRecordSize = 50;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);

  useEffect(() => {
    // dispatch(
    //   getAllClinicPaymentOfHugeRecord(
    //     `?filter=${selectedType}&type=${selectMode}&page=1&itemSize=${hugeRecordSize}`
    //   )
    // );
    // onPaymentsApiCall(1);

    // Reset filter values to initial state when component mounts
    setFilterValues({ ...initFilter, selectedList: [], values: {} });

    dispatch(getClinicStocks());
    dispatch(getServices());
    dispatch(getPaymentMethods());
    dispatch(getClinicVets());
  }, []);

  // useEffect(() => {
  //   let url = `?filter=${selectedType}&source=${selectedSource}&type=${selectMode}&page=1&itemSize=${itemsPerLoad}`;
  //   if (selectedType === "outstanding") {
  //     url = `?filter=all&source=${selectedSource}&type=Unpaid&page=1&itemSize=${itemsPerLoad}`;
  //   }
  //   dispatch(getAllClinicPayment(url)).then((res) => {
  //     if (posPayId && res?.payload?.data?.length > 0) {
  //       const reqBil = res?.payload?.data?.find(
  //         (li) => li?.paymentId === posPayId
  //       );
  //       if (reqBil) {
  //         setSelectedBill(reqBil);
  //         setInvModVisible(true);
  //       }
  //     }
  //   });
  //   setPage(1);
  // }, [selectMode, selectedType, posPayId, selectedSource]);

  // useEffect(() => {
  //   const filteredPayments = filterPayments(
  //     searchText?.length > 0 ? hugePayments?.data : payments?.data,
  //     searchText
  //   );
  //   getTablePayments(filteredPayments);
  // }, [payments?.data, hugePayments?.data, searchText]);

  useEffect(() => {
    // Only call API if there are actual search values
    // const hasSearchValues =
    //   searchValues?.petName?.trim() ||
    //   searchValues?.userName?.trim() ||
    //   searchValues?.vetName?.trim() ||
    //   searchValues?.startDate ||
    //   searchValues?.endDate;
    // if (hasSearchValues) {
    onPaymentsApiCall(1);
    // }
  }, [
    searchValues?.petName,
    searchValues?.userName,
    searchValues?.vetName,
    searchValues?.startDate,
    searchValues?.endDate,
  ]);

  const getFilterObj = (currentPage = 1, reset = false) => {
    setPage(currentPage);
    const reqObj = { page: currentPage, itemSize: itemsPerLoad };
    if (reset) return reqObj;
    if (searchValues?.petName?.length > 0)
      reqObj.petName = searchValues?.petName;
    if (searchValues?.userName?.length > 0)
      reqObj.username = searchValues?.userName;
    if (searchValues?.vetName?.length > 0)
      reqObj.vetName = searchValues?.vetName;
    if (searchValues?.startDate) {
      reqObj.startDate = moment(
        new Date(new Date(searchValues?.startDate) ?? new Date())
      ).format("YYYY-MM-DD");
    }
    if (searchValues?.endDate) {
      reqObj.endDate = moment(
        new Date(new Date(searchValues?.endDate) ?? new Date())
      ).format("YYYY-MM-DD");
    }
    if (
      filterValues?.selectedList?.includes("Invoice Number") &&
      filterValues?.values?.["Invoice Number"]?.length > 0
    ) {
      reqObj.invoiceNumber = filterValues?.values?.["Invoice Number"];
    }
    if (filterValues?.selectedList?.includes("Balance Due")) {
      reqObj.balanceDueMin = Number(
        filterValues?.values?.["Min Balance Due"] ?? 0
      );
      reqObj.balanceDueMax = Number(
        filterValues?.values?.["Max Balance Due"] ?? 0
      );
    }
    if (
      filterValues?.selectedList?.includes("Status") &&
      filterValues?.values?.["Status"]?.length > 0
    ) {
      reqObj.status = filterValues?.values?.["Status"]?.some(
        (li) => li?.value === "all"
      )
        ? ["paid", "unpaid", "ppaid"]
        : filterValues?.values?.["Status"]?.map((li) => li?.value);
    }
    if (
      filterValues?.selectedList?.includes("Type") &&
      filterValues?.values?.["Type"]?.length > 0
    ) {
      reqObj.type = filterValues?.values?.["Type"]?.map((li) => li?.value);
    }
    if (
      filterValues?.selectedList?.includes("Invoice Type") &&
      filterValues?.values?.["Invoice Type"]?.length > 0
    ) {
      reqObj.invoiceType = filterValues?.values?.["Invoice Type"]?.map(
        (li) => li?.value
      );
    }
    if (
      filterValues?.selectedList?.includes("Payment Mode") &&
      filterValues?.values?.["Payment Mode"]?.length > 0
    ) {
      reqObj.paymentMode = filterValues?.values?.["Payment Mode"]?.map(
        (li) => li?.value
      );
    }
    if (
      filterValues?.selectedList?.includes("Person In Charge") &&
      filterValues?.values?.["Person In Charge"]
    ) {
      reqObj.personInCharge = filterValues?.values?.["Person In Charge"];
    }
    return reqObj;
  };

  const onPaymentsApiCall = (currentPage = 1, reset = false) => {
    dispatch(getClinicPaymentsByFilter(getFilterObj(currentPage, reset)));
  };

  const createModalOpen = (li, balDue) => {
    setModalData(li);
    setTotalBalanceDue(balDue);
    if (li?.advanceAmount && Number(li?.advanceAmount) <= 0) {
      const filtered = PaymentTypeList.filter(
        (list) => list?.value !== "advanceAdjustment"
      );
      setEnabledPaymentTypes(filtered);
    } else {
      setEnabledPaymentTypes(PaymentTypeList);
    }
    setPayValues({ ...payValues, amount: balDue });
    setPayModalVisible(true);
  };

  const filterPayments = (payments, searchText) => {
    if (!searchText) return payments;

    return payments?.filter((payment) => {
      const petNameMatch = payment?.petName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const vetNameMatch = payment?.doctorName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userNameMatch = payment?.userName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userEmailMatch = payment?.email
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userMobileMatch = payment?.mobile
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const paymentStatusMatch = payment?.status
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      return (
        petNameMatch ||
        vetNameMatch ||
        paymentStatusMatch ||
        userNameMatch ||
        userEmailMatch ||
        userMobileMatch
      );
    });
  };

  const handleChangeValues = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    setPayValues({ ...payValues, [name]: value });
    const errObj = {
      ...payErr,
      [name]: reqValue?.length > 0 ? "" : "This field is required",
    };
    if (name === "paymentMode") {
      if (reqValue !== "advanceAdjustment") {
        errObj.amount = "";
      }
      if (reqValue === "advanceAdjustment") {
        if (Number(modalData?.advanceAmount ?? 0) <= 0) {
          errObj.amount = "Insufficient credit balance";
        }
      }
    }
    if (name === "amount") {
      if (payValues?.paymentMode?.value === "advanceAdjustment") {
        errObj.amount =
          Number(value) < 0
            ? "Amount must be positive"
            : Number(value) > Number(modalData?.advanceAmount)
            ? "Insufficient credit balance"
            : "";
      } else {
        errObj.amount = Number(value) < 0 ? "Amount must be positive" : "";
      }
      if (Number(value) > totalBalanceDue) {
        errObj.amount = "Amount must be less than or equal to balance due";
      }
    }
    setPayErr(errObj);
  };

  const handleReturns = (bill) => {
    setReturnValue({
      refundMethod: "cash",
      list: bill?.paymentDetails
        ?.filter((li) => li?.credit === "N" && li?.stockId)
        ?.map((li) => ({
          ...li,
          returnQuantity: 0,
        })),
    });
    setSelectedBill(bill);
    setReturnModVsble(true);
  };

  const getTablePayments = (payments) => {
    // dispatch(showLoader());
    const requiredPayments = paymentsByFilter?.data?.map((pay, i) => {
      const balDue = Number(
        Number(
          getTaxAndSubTotalAndTotalForTreatment(
            getTreatmentRecordBasedType(pay?.paymentDetails),
            services?.data,
            pay?.procedure ?? []
          )?.subTotal +
            getTaxAndSubTotalAndTotal(
              getPharmacyRecordBasedType(pay?.paymentDetails)
            )?.subTotal
        ) -
          // (
          Number(pay?.amtPaid ?? 0)
        //  - Number(pay?.discount ?? 0))
      );

      return {
        ...pay,
        payType:
          pay?.type === "Pharmacy" || pay?.type === "Pet Shop"
            ? pay?.type
            : "Clinic",
        petName: pay?.petName ?? pay?.userName,
        petImage: pay?.petImage,
        balanceDue: Number(balDue) > 0 ? Number(balDue)?.toFixed(2) : "Nil",
        trDate: moment(pay?.createdDate).format("DD MMM YYYY"),
        vetName: `${pay?.clinicId === pay?.doctorId ? "" : "Dr. "}${
          pay?.doctorName
        }`,
        paymentStatus:
          pay?.status === "paid"
            ? "Paid"
            : pay?.status === "partiallypaid"
            ? "Partially Paid"
            : "Unpaid",
        gender: pay?.gender,
        breed: pay?.breed,
        pay: (
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            {["unpaid", "partiallypaid"].includes(pay?.status) ? (
              <img
                src={payImg}
                alt=""
                className="img-hw40"
                onClick={() => {
                  createModalOpen(pay, balDue);
                }}
              />
            ) : (
              <div className="img-hw40" />
            )}
            <img
              src={viewImg}
              alt=""
              className="img-hw40"
              onClick={() => {
                if (
                  pay?.appointmentStatus === "completed" ||
                  pay?.status === "paid" ||
                  pay?.type === "Pet Shop" || //for direct billing
                  pay?.type === "Pharmacy" //for direct billing
                ) {
                  dispatch(getCompliantSummaryByIdWoLoader(pay?.appointmentId));
                  setSelectedBill(pay);
                  return setInvModVisible(true);
                }
                if (
                  pay?.appointmentStatus !== "completed" &&
                  pay?.status !== "paid"
                ) {
                  return navigate("/clinic-pet-details", {
                    state: {
                      bill: pay,
                      selectedTab: "billing",
                      appointment: {
                        appoinment: {
                          appointmentId: pay?.appointmentId,
                          petId: pay?.petId,
                        },
                      },
                      editBill: true, //for landing to the bill directly
                    },
                  });
                }
              }}
            />
            {pay?.creditNote !== "Credit" ? (
              <div onClick={() => handleReturns(pay)}>
                <div className="flex-coloum">
                  <div className="flex-center">
                    <KeyboardReturnIcon sx={{ color: AppColors.red }} />
                  </div>
                  <Typography className="red-color fs10 flex-center font-medium">
                    Return
                  </Typography>
                </div>
              </div>
            ) : null}
          </div>
        ),
        userName:
          pay?.type === "Pharmacy" || pay?.type === "Pet Shop"
            ? null
            : pay?.userName,
      };
    });
    // setTablePayments(requiredPayments);

    // dispatch(hideLoader());
    return requiredPayments;
  };

  const handleSelectMode = async (mode) => {
    setSelectMode(mode.target.value);
  };

  const handleSelectType = async (type) => {
    setSelectedType(type);
  };

  const handlePrint = useReactToPrint({
    documentTitle: `${clinicDet?.name ?? ""}-${
      selectedBill?.invoiceNumbers ?? ""
    }`,
    removeAfterPrint: true,
  });

  const finalPayment = () => {
    //validation start
    let errs = {};
    if (
      !payValues?.amount ||
      isNaN(Number(payValues?.amount)) ||
      Number(payValues?.amount) <= 0 ||
      Number(payValues?.amount) > totalBalanceDue ||
      (payValues?.paymentMode?.value === "advanceAdjustment" &&
        Number(payValues?.amount) > Number(modalData?.advanceAmount))
    ) {
      errs = {
        ...errs,
        amount:
          payValues?.paymentMode?.value === "advanceAdjustment" &&
          Number(payValues?.amount) > Number(modalData?.advanceAmount)
            ? "Insufficient credit balance"
            : !payValues?.amount
            ? "This field is required"
            : Number(payValues?.amount) > totalBalanceDue
            ? "Amount must be less than or equal to balance due"
            : Number(payValues?.amount) <= 0
            ? "Amount must be positive"
            : "",
      };
    }

    if (Number(payValues?.amount) > totalBalanceDue) {
      errs = {
        ...errs,
        amount: "Amount must be less than or equal to balance due",
      };
    }

    if (!payValues?.paymentMode?.value) {
      errs = { ...errs, paymentMode: "This field is required" };
    }
    if (Object.values(errs).some((item) => item?.length > 0)) {
      return setPayErr(errs);
    }
    //validation end here
    const data = {
      paymentId: modalData.paymentId,
      paymentMode: payValues?.paymentMode?.value,
      paymentAmount: Number(payValues?.amount),
      // payValues?.paymentMode?.value === "advanceAdjustment"
      //   ? Number(modalData?.advanceAmount)
      //   : payValues?.amount,
    };
    dispatch(updatePayment(data)).then(async (res) => {
      if (res?.payload) {
        // dispatch(
        //   getAllClinicPayment(
        //     `?filter=${selectedType}&source=${selectedSource}&type=${selectMode}&page=${page}&itemSize=${itemsPerLoad}`
        //   )
        // );
        onPaymentsApiCall(1);
        setPayModalVisible(false);
        setPayValues(initialValues);
        setTotalBalanceDue(0);
        handleInvModClose();
        setPayErr({});
        setModalData(null);
      }
    });
  };

  const handleInvModClose = () => {
    setPosPayId(null);
    setSelectedBill(null);
    setInvModVisible(false);
  };

  const handleChangePage = (e, selectedPage) => {
    onPaymentsApiCall(selectedPage);
    // let url = `?filter=${selectedType}&source=${selectedSource}&type=${selectMode}&page=${selectedPage}&itemSize=${itemsPerLoad}`;
    // if (selectedType === "outstanding") {
    //   url = `?filter=all&source=${selectedSource}&type=Unpaid&page=${selectedPage}&itemSize=${itemsPerLoad}`;
    // }
    // dispatch(getAllClinicPayment(url));
    // setPage(selectedPage);
  };

  const handleClosePayMod = () => {
    setPayModalVisible(false);
    setModalData(null);
    setPayValues(initialValues);
    setTotalBalanceDue(0);
    setPayErr({});
  };

  const onCloseRetMod = () => {
    setReturnModVsble(false);
    setSelectedBill(null);
  };

  const handleChange = (name, value) => {
    setReturnValue({ ...returnValue, [name]: value });
  };

  const handleChangeRetQty = (value, ind) => {
    const reqList = returnValue?.list?.map((li, i) => {
      if (i === ind) {
        const reqObj = {
          ...li,
          returnQuantity: value,
          returnQuantityErr:
            Number(li?.quantity) < Number(value) ? "Maximum limit reached" : "",
        };
        return reqObj;
      }
      return li;
    });
    const reqValue = { ...returnValue, list: reqList };
    if (listNotValid) {
      if (reqList?.some((li) => Number(li?.returnQuantity) > 0)) {
        setListNotValid(false);
      }
    }
    setReturnValue(reqValue);
  };

  const submitReturn = (status = "") => {
    const returnList = returnValue?.list?.filter(
      (li) => Number(li?.returnQuantity) > 0
    );
    if (returnList?.length === 0 || !returnList) return setListNotValid(true);
    const paymentDetails = returnList?.map((li) => {
      const reqbj = {
        tax: isNaN(Number(Number(li?.tax) / Number(li?.quantity)))
          ? 0
          : Number(Number(li?.tax) / Number(li?.quantity)),
        price: li?.price,
        total: isNaN(Number(Number(li?.total) / Number(li?.quantity)))
          ? 0
          : Number(Number(li?.total) / Number(li?.quantity)),
        returnQuantity: Number(li?.returnQuantity),
        name: li?.name,
      };
      if (li?.serviceId) reqbj.serviceId = li?.serviceId;
      if (li?.stockId) reqbj.stockId = li?.stockId;
      if (li?.batchId) reqbj.batchId = li?.batchId;
      return reqbj;
    });
    const data = {
      paymentMode: returnValue?.refundMethod,
      paymentDetails,
      creditSave: status,
      remarks: returnValue?.remarks ?? "",
    };
    dispatch(
      updateBillingItemsReturn({ data, id: selectedBill?.paymentId })
    ).then((res) => {
      if (res?.payload) {
        // dispatch(
        //   getAllClinicPayment(
        //     `?filter=${selectedType}&source=${selectedSource}&type=${selectMode}&page=${page}&itemSize=${itemsPerLoad}`
        //   )
        // );
        onPaymentsApiCall(1);
        onCloseRetMod();
      }
    });
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    };
    setSearchValues(reqObj);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onPaymentsApiCall(1);
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = { ...initFilter, visible: true };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onPaymentsApiCall(1);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onPaymentsApiCall(1, true);
  };

  const getPaymentMethodList = () => {
    return (
      paymentMethod?.list?.map((li) => ({
        name: li?.name,
        value: li?.name,
      })) ?? []
    );
  };

  const getClinicVetList = () => {
    return (
      clinicVets
        ?.filter((vl) => {
          if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
            return vl;
          }
        })
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.name, id: vet?.doctorId };
        }) ?? []
    );
  };

  const getBatch = (stkId = null, batchId = null) => {
    if (!stkId || !batchId) return null;
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stkId);
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  return (
    <>
      <Grid container className="ph2">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="back-white"
        >
          <TopBar>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <div className="top-row-cen-con w100Per">
                  <div className="w15Per">
                    <CustomTextField
                      placeholder="Pet Name"
                      fullWidth
                      name="petName"
                      handleChange={onSearchChange}
                      value={searchValues?.petName}
                      backgroundColor={AppColors.lightBlue2}
                      label="Pet Name"
                    />
                  </div>
                  <div className="w15Per ml15">
                    <CustomTextField
                      placeholder="User Name"
                      fullWidth
                      name="userName"
                      handleChange={onSearchChange}
                      value={searchValues?.userName}
                      backgroundColor={AppColors.lightBlue2}
                      label="User Name"
                    />
                  </div>
                  <div className="w15Per ml15">
                    <CustomTextField
                      placeholder="Vet Name"
                      fullWidth
                      name="vetName"
                      handleChange={onSearchChange}
                      value={searchValues?.vetName}
                      backgroundColor={AppColors.lightBlue2}
                      label="Vet Name"
                    />
                  </div>
                  <div className="w12Per ml15">
                    <CustomTextField
                      placeholder="Start Date"
                      fullWidth
                      name="startDate"
                      handleChange={onSearchChange}
                      value={searchValues?.startDate}
                      backgroundColor={AppColors.lightBlue2}
                      mobileDate
                      label="Start Date"
                    />
                  </div>
                  <div className="w12Per ml15">
                    <CustomTextField
                      placeholder="End Date"
                      fullWidth
                      name="endDate"
                      handleChange={onSearchChange}
                      value={searchValues?.endDate}
                      backgroundColor={AppColors.lightBlue2}
                      mobileDate
                      label="End Date"
                    />
                  </div>
                  <div
                    className="flex-row-ali-cen ml15 filter cursor"
                    onClick={() => onFilterChange("visible", true)}
                  >
                    <TuneIcon sx={{ color: AppColors.appPrimary }} />
                    <Typography className="font-medium fs12 blue-color ml10">
                      {filterValues?.selectedList?.length > 0
                        ? `${filterValues?.selectedList?.length} `
                        : ""}
                      Filter
                    </Typography>
                  </div>
                  <div className="ml15">
                    <CustomButton
                      text="Reset"
                      onClick={onReset}
                      smallBtn
                      redBtn
                    />
                  </div>
                </div>
              </div>
              {/* <div className="flex-row-ali-cen">
                <div className="flex-center ml10">
                  <Typography
                    className={`font-bold fs14 cursor day-type-box ${
                      selectedType === "today" ? "black" : "gray2"
                    }`}
                    onClick={() => handleSelectType("today")}
                  >
                    Today
                  </Typography>
                  <Typography
                    className={`font-bold fs14 cursor day-type-box ${
                      selectedType === "outstanding" ? "black" : "gray2"
                    }`}
                    onClick={() => handleSelectType("outstanding")}
                  >
                    Outstanding
                  </Typography>
                  <Typography
                    className={`font-bold fs14 cursor day-type-box ${
                      selectedType === "all" ? "black" : "gray2"
                    }`}
                    onClick={() => handleSelectType("all")}
                  >
                    All
                  </Typography>
                </div>

                <div className="top-row-cen-con w100Per">
                  <div className="w50Per">
                    <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearchText(e.target.value)}
                      value={searchText}
                      searchBill
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>
                </div>

                // <div className="w20Per pr20">
                //   <Select
                //     list={paymentFilters}
                //     value={selectMode ?? "all"}
                //     handleChange={(e) => handleSelectMode(e)}
                //     name="vet"
                //   />
                // </div>
              </div> */}
            </Grid>
            <Typography className="font-medium fs12 gray28 mt10 mb10Min">
              Number of Records: {paymentsByFilter?.totalRecords ?? 0}
            </Typography>
          </TopBar>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="mv3 back-white"
        >
          {/* <div className="flex-row-ali-cen ph20 ml5">
            <Typography
              className={`txt-semi-bold fs12 gray-back2 cursor ${
                selectedSource === "all" ? "tab-green-back" : "tab-gray-back"
              }`}
              onClick={() => setSelectedSource("all")}
            >
              All
            </Typography>
            <Typography
              className={`txt-semi-bold fs12 gray-back2 cursor ml15 ${
                selectedSource === "Clinic" ? "tab-green-back" : "tab-gray-back"
              }`}
              onClick={() => setSelectedSource("Clinic")}
            >
              Clinic
            </Typography>
            <Typography
              className={`txt-semi-bold fs12 gray-back2 cursor ml15 ${
                selectedSource === "Pet Shop"
                  ? "tab-green-back"
                  : "tab-gray-back"
              }`}
              onClick={() => setSelectedSource("Pet Shop")}
            >
              Pet Shop
            </Typography>
            <div
              className={`txt-semi-bold fs12 gray-back2 cursor ml15 ${
                selectedSource === "Pharmacy"
                  ? "tab-green-back"
                  : "tab-gray-back"
              }`}
              onClick={() => setSelectedSource("Pharmacy")}
            >
              Pharmacy
            </div>
          </div> */}
          <Table
            columns={tableHeaders}
            datas={getTablePayments()}
            onClickPay={() => {}}
            page={page}
            rowsPerPage={itemsPerLoad}
            grey
            totalRecords={paymentsByFilter?.totalRecords}
            handleChangePage={handleChangePage}
            maxHeight={400}
          />
        </Grid>
      </Grid>
      <CustomModal
        open={payModalVisible}
        onClose={handleClosePayMod}
        header="Pay"
        rightModal
        modalWidth={30}
      >
        <div className="flex-center">
          <Card
            sx={{
              borderRadius: 1,
              padding: 2,
              borderTopColor: `${getBorderColor(modalData?.status)}`,
            }}
            className="pay-card"
          >
            <div className="flex-row">
              <div className="w50Per">
                <Typography className="fs12 txt-semi-bold gray14">
                  Pet Name
                </Typography>
                <Typography className="fs14 txt-semi-bold black">
                  {modalData?.petName}
                </Typography>
              </div>
              <div className="w50Per">
                <Typography className="fs12 txt-semi-bold gray14">
                  Parent Name
                </Typography>
                <Typography className="fs14 txt-semi-bold black">
                  {modalData?.userName}
                </Typography>
              </div>
            </div>
            <div className="mh20Min">
              <div className="gry-hor-split3 mv5" />
            </div>
            <div className="mt10">
              <Typography className="txt-regular fs14 gray7">
                {moment(new Date(modalData?.createdDate)).format(
                  "DD MMM, YYYY"
                )}
              </Typography>
              <div className="bil-his-box mt5">
                <div className="flex-row">
                  <div className="flex-start">
                    <Typography className="fs14 font-medium black">
                      {modalData?.invoiceNumbers ??
                        modalData?.treatmentInvoiceNumber}
                    </Typography>
                  </div>
                  <div className="flex1-end">
                    <Typography className="txt-semi-bold fs14 orange3">
                      {Number(
                        Number(
                          getTaxAndSubTotalAndTotalForTreatment(
                            getTreatmentRecordBasedType(
                              modalData?.paymentDetails
                            ),
                            services?.data,
                            modalData?.procedure ?? []
                          )?.subTotal +
                            getTaxAndSubTotalAndTotal(
                              getPharmacyRecordBasedType(
                                modalData?.paymentDetails
                              )
                            )?.subTotal
                        ) -
                          // (
                          Number(modalData?.amtPaid ?? 0)
                        //  -
                        // Number(modalData?.discount ?? 0))
                      ) > 0
                        ? `Rs ${Number(
                            Number(
                              getTaxAndSubTotalAndTotalForTreatment(
                                getTreatmentRecordBasedType(
                                  modalData?.paymentDetails
                                ),
                                services?.data,
                                modalData?.procedure ?? []
                              )?.subTotal +
                                getTaxAndSubTotalAndTotal(
                                  getPharmacyRecordBasedType(
                                    modalData?.paymentDetails
                                  )
                                )?.subTotal
                            ) -
                              // (
                              Number(modalData?.amtPaid ?? 0)
                            //  -
                            // Number(modalData?.discount ?? 0))
                          )?.toFixed(2)}`
                        : "Nil"}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            {modalData?.appointmentType ? (
              <div
                className={`conttype ${
                  modalData?.appointmentType === "Physical"
                    ? "card-con-blue-back"
                    : "virtual-bg-color"
                }`}
              >
                {modalData?.appointmentType}
              </div>
            ) : null}
          </Card>
        </div>
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <CustomTextField
              label="Amount"
              name="amount"
              fullWidth
              handleChange={(e) =>
                handleChangeValues("amount", e?.target?.value)
              }
              value={payValues?.amount}
              error={!!payErr?.amount}
              helperText={payErr?.amount}
              labelTop
              type="number"
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="font-medium fs14 black2">Payment Mode</div>
            {/* <Select
              list={
                (profile?.id || profile?.createdBy) === RMVClinicId
                  ? RMVPaymentTypeList
                  : enabledPaymentTypes
              }
              value={payValues?.paymentMode}
              error={!!payErr?.paymentMode}
              helperText={payErr?.paymentMode}
              handleChange={(e, value) =>
                handleChangeValues("paymentMode", value)
              }
              name="paymentMode"
              search
            /> */}
            <PaymentModeDropdown
              list={
                (profile?.id || profile?.createdBy) === RMVClinicId
                  ? RMVPaymentTypeList
                  : enabledPaymentTypes
              }
              value={payValues?.paymentMode}
              error={!!payErr?.paymentMode}
              helperText={payErr?.paymentMode}
              onChange={(e, value) => handleChangeValues("paymentMode", e)}
              name="paymentMode"
              label=""
            />
          </Grid>
          {payValues?.paymentMode?.value === "advanceAdjustment" ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="txt-semi-bold fs14 orange5">
                Available Balance:{" "}
                {Number(modalData?.advanceAmount) > 0
                  ? Number(modalData?.advanceAmount)?.toFixed(2)
                  : "-"}
              </Typography>
            </Grid>
          ) : null}
          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Pay" onClick={finalPayment} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={invModVisible}
        onClose={handleInvModClose}
        header=""
        modal
        modalWidth={90}
      >
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <div ref={contentToPrint} className="bg">
            {getTreatmentRecordBasedType(selectedBill?.paymentDetails)?.length >
            0 ? (
              <>
                {selectedBill?.type !== "Pharmacy" &&
                selectedBill?.type !== "Pet Shop" ? (
                  <div className="mt30">
                    <div className="flex-row-ali-cen mv20">
                      <div className="w30Per">
                        <div className="pl20">
                          <div>
                            {clinicDet?.image ? (
                              <img
                                src={clinicDet?.image}
                                className="img-h75"
                                alt=""
                              />
                            ) : (
                              <div className="flex-center h50img">
                                <Typography className="font-bold fs30 white-color capitalize">
                                  {clinicDet?.name?.[0]}
                                </Typography>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="w40Per flex-center">
                        <div className="font-bold fs18 blue-color">
                          TREATMENT INVOICE
                        </div>
                      </div>
                      <div className="w30Per flex1-end">
                        <div className="flex-column">
                          <div className="font-bold fs12 blue-color">
                            Business Name:
                          </div>
                          <div className="font-medium blue-color fs12">
                            {clinicDet?.name ?? profile?.name ?? ""}
                          </div>
                          <div className="font-bold fs12 blue-color">
                            Business Address:
                          </div>
                          <div className="header-right-text2">
                            {clinicDet?.address ?? ""}
                          </div>
                          {clinicDet?.taxId?.length > 0 ? (
                            <div className="flex-row-ali-cen">
                              <div className="font-bold fs12 blue-color">
                                CLINIC TAX ID:{" "}
                              </div>
                              <div className="header-right-text2 ml3">
                                {clinicDet?.taxId ?? ""}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {clinicDet?.mobile?.length > 0 ? (
                            <div className="flex-row-ali-cen">
                              <div className="font-bold fs12 blue-color">
                                Contact:{" "}
                              </div>
                              <div className="header-right-text2 ml3">
                                {clinicDet?.mobile ?? ""}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="line" />
                    <div className="flex-row mt10 ph30">
                      <div className="w60Per">
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 gray4">
                            Parent Name
                          </Typography>
                          <div className="txt-semi-bold fs14 black capitalize ml10">
                            {selectedBill?.userName}
                          </div>
                        </div>
                        {selectedBill?.mobile?.length > 0 ? (
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Phone Number
                            </Typography>
                            <div className="txt-semi-bold fs14 black capitalize ml10">
                              {selectedBill?.mobile}
                            </div>
                          </div>
                        ) : null}
                        {selectedBill?.apartmentAddress?.length > 0 ? (
                          <div className="flex-row">
                            <Typography className="font-bold fs14 gray4">
                              Address
                            </Typography>

                            <div className="txt-semi-bold fs14 black capitalize ml10 w50Per flex-row-wrap">
                              {selectedBill?.apartmentAddress}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="flex1-end w40Per">
                        <div className="flex-column">
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Payment Status
                            </Typography>
                            <Typography
                              className={`ml10 fs16 font-bold capitalize ${
                                selectedBill?.status === "paid"
                                  ? "green2"
                                  : selectedBill?.status === "unpaid"
                                  ? "red2"
                                  : "orange-color"
                              }`}
                            >
                              {selectedBill?.status === "partiallypaid"
                                ? "Partially Paid"
                                : selectedBill?.status}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Total
                            </Typography>
                            <Typography className="black fs16 font-bold ml10">
                              Rs{" "}
                              {Number(
                                getTaxAndSubTotalAndTotalForTreatment(
                                  getTreatmentRecordBasedType(
                                    selectedBill?.paymentDetails
                                  ),
                                  services?.data,
                                  lastSummary?.procedures ??
                                    selectedBill?.procedure ??
                                    []
                                )?.subTotal +
                                  getTaxAndSubTotalAndTotal(
                                    getPharmacyRecordBasedType(
                                      selectedBill?.paymentDetails
                                    )
                                  )?.subTotal
                              )?.toFixed(2)}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Amount Paid
                            </Typography>
                            <Typography className="green-color fs16 font-bold ml10">
                              Rs{" "}
                              {Number(selectedBill?.amtPaid) > 0
                                ? Number(selectedBill?.amtPaid)?.toFixed(2)
                                : Number(selectedBill?.amtPaid)}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Balance Due
                            </Typography>
                            <Typography className="yellow-color fs16 font-bold ml10">
                              Rs{" "}
                              {Number(
                                Number(
                                  getTaxAndSubTotalAndTotalForTreatment(
                                    getTreatmentRecordBasedType(
                                      selectedBill?.paymentDetails
                                    ),
                                    services?.data,
                                    lastSummary?.procedures ??
                                      selectedBill?.procedure ??
                                      []
                                  )?.subTotal +
                                    getTaxAndSubTotalAndTotal(
                                      getPharmacyRecordBasedType(
                                        selectedBill?.paymentDetails
                                      )
                                    )?.subTotal
                                ) -
                                  // (
                                  Number(selectedBill?.amtPaid ?? 0)
                                //  -
                                // Number(
                                //   getTaxAndSubTotalAndTotalForTreatment(
                                //     getTreatmentRecordBasedType(
                                //       selectedBill?.paymentDetails
                                //     ),
                                //     services?.data,
                                //     lastSummary?.procedures ??
                                //       selectedBill?.procedure ??
                                //       []
                                //   )?.discount +
                                //     getTaxAndSubTotalAndTotal(
                                //       getPharmacyRecordBasedType(
                                //         selectedBill?.paymentDetails
                                //       )
                                //     )?.discount
                                // ) ?? 0)
                              )?.toFixed(2)}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="lower-container">
                      <div className="box-container">
                        <div className="row-container">
                          <div>
                            <div className="colum-header">Pet Name</div>
                            <div className="colum-data">
                              {selectedBill?.petName}
                            </div>
                          </div>
                          <div>
                            <div className="colum-header">Vet Name</div>
                            <div className="colum-data capitalize">
                              {selectedBill?.doctorId === selectedBill?.clinicId
                                ? ""
                                : "Dr. "}
                              {selectedBill?.doctorName}
                            </div>
                          </div>
                          <div>
                            <div className="colum-header">Invoice Number</div>
                            <div className="colum-data">
                              {selectedBill?.treatmentInvoiceNumber ?? ""}
                            </div>
                          </div>
                          <div>
                            <div className="colum-header">Invoice Date</div>
                            <div className="colum-data">
                              {moment(
                                new Date(selectedBill?.createdDate)
                              ).format("DD MMM YYYY")}
                            </div>
                          </div>
                        </div>

                        <div className="thin-line"></div>

                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>HSN/SAC Code</th>
                              <th>SERVICE / ITEM NAME</th>
                              <th>QTY</th>
                              <th>UNIT PRICE</th>
                              {getTreatmentRecordBasedType(
                                selectedBill?.paymentDetails
                              )?.some((li) => li?.discount > 0) ? (
                                <th>UNIT DISCOUNT (Rs)</th>
                              ) : null}
                              <th>TOTAL</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getTreatmentRecordBasedType(
                              selectedBill?.paymentDetails
                            )?.length > 0 &&
                              getTreatmentRecordBasedType(
                                selectedBill?.paymentDetails
                              )
                                ?.filter((pd) => pd?.type === "consultation")
                                ?.map((con) => (
                                  <tr>
                                    <td>-</td>
                                    <td>
                                      <div className="flex-row-ali-cen">
                                        Consultation (
                                        {con?.name === "Home"
                                          ? "Home Visit"
                                          : con?.name}
                                        ){" "}
                                        {selectedBill?.doctorName?.length > 0
                                          ? " - "
                                          : ""}
                                        <div className="font-bold fs12 black ml3">
                                          {selectedBill?.doctorName?.length > 0
                                            ? `${
                                                selectedBill?.doctorId ===
                                                selectedBill?.clinicId
                                                  ? ""
                                                  : "Dr. "
                                              } ${selectedBill?.doctorName}`
                                            : ""}
                                        </div>
                                        {selectedBill?.registrationNo?.length >
                                        0 ? (
                                          <div className="flex-row-ali-cen">
                                            <div className="font-regular fs12 black ml5">
                                              (
                                            </div>
                                            <div className="font-bold fs12 black ml2">
                                              RegNo:
                                            </div>
                                            <div className="font-regular fs12 black ml5 capitalize">
                                              {selectedBill?.registrationNo ??
                                                selectedBill?.registrationNo}{" "}
                                              )
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </td>
                                    <td>1</td>
                                    <td>Rs {Number(con?.price)?.toFixed(2)}</td>
                                    {getTreatmentRecordBasedType(
                                      selectedBill?.paymentDetails
                                    )?.some((li) => li?.discount > 0) ? (
                                      <td>
                                        {con?.tax > 0
                                          ? Number(con?.tax)?.toFixed(2)
                                          : "-"}
                                      </td>
                                    ) : null}
                                    <td>Rs {Number(con?.total)?.toFixed(2)}</td>
                                  </tr>
                                ))}

                            {getTreatmentRecordBasedType(
                              selectedBill?.paymentDetails
                            )?.length > 0 &&
                              reorderList(
                                getTreatmentRecordBasedType(
                                  selectedBill?.paymentDetails
                                )
                              )
                                ?.filter((pd) =>
                                  pd?.type !== "consultation" &&
                                  pd?.type?.toLowerCase() !== "consumables" &&
                                  selectedBill?.showSublineItems
                                    ? true
                                    : pd?.patientWorkbook
                                    ? pd?.mainProcedure
                                    : true
                                )
                                ?.map((itm, i) => {
                                  const isSubItem =
                                    itm?.patientWorkbook && !itm?.mainProcedure;
                                  const showSubPrice =
                                    selectedBill?.showSublinePrice;
                                  let stock = null;
                                  if (itm?.batchId) {
                                    stock = stocks?.data?.find(
                                      (stc) => stc?.stockId === itm?.stockId
                                    );
                                  }
                                  if (itm?.serviceId) {
                                    stock = services?.data?.find(
                                      (ser) => ser?.serviceId === itm?.serviceId
                                    );
                                  }
                                  const reqTotal = showSubPrice
                                    ? itm?.total ?? 0
                                    : itm?.list?.length > 0
                                    ? Number(
                                        Number(
                                          itm?.list
                                            ?.filter((li) =>
                                              selectedBill?.showSublinePrice
                                                ? li?.type?.toLowerCase() !==
                                                  "consumables"
                                                : true
                                            )
                                            ?.reduce(
                                              (acc, li) =>
                                                acc + Number(li?.total),
                                              0
                                            ) ?? 0
                                        ) + Number(itm?.total ?? 0)
                                      )
                                    : itm?.total ?? 0;
                                  const reqUnitPrice = showSubPrice
                                    ? itm?.mrpPrice ?? itm?.price ?? 0
                                    : itm?.list?.length > 0
                                    ? Number(
                                        Number(
                                          itm?.list
                                            ?.filter((li) =>
                                              selectedBill?.showSublinePrice
                                                ? li?.type?.toLowerCase() !==
                                                  "consumables"
                                                : true
                                            )
                                            ?.reduce(
                                              (acc, li) =>
                                                acc +
                                                Number(
                                                  li?.mrpPrice ?? li?.price
                                                ),
                                              0
                                            ) ?? 0
                                        ) +
                                          Number(
                                            itm?.mrpPrice ?? itm?.price ?? 0
                                          )
                                      )
                                    : itm?.mrpPrice ?? itm?.price ?? 0;

                                  const reqDiscount = showSubPrice
                                    ? itm?.discount ?? 0
                                    : itm?.list?.length > 0
                                    ? Number(
                                        Number(
                                          itm?.list
                                            ?.filter((li) =>
                                              selectedBill?.showSublinePrice
                                                ? li?.type?.toLowerCase() !==
                                                  "consumables"
                                                : true
                                            )
                                            ?.reduce(
                                              (acc, li) =>
                                                acc + Number(li?.discount),
                                              0
                                            ) ?? 0
                                        ) + Number(itm?.discount ?? 0)
                                      )
                                    : itm?.discount ?? 0;

                                  return (
                                    <>
                                      <tr key={i}>
                                        <td>
                                          <div className="fs12 font-bold black">
                                            {stock?.hsnSacCode?.length > 0
                                              ? stock?.hsnSacCode
                                              : "-"}
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            className={
                                              isSubItem
                                                ? ""
                                                : "fs12 font-bold black"
                                            }
                                          >
                                            {itm?.name}
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            className={
                                              isSubItem
                                                ? ""
                                                : "fs12 font-bold black"
                                            }
                                          >
                                            {itm?.quantity}
                                            {itm?.stockId &&
                                            itm?.batchId &&
                                            itm?.patientWorkbook &&
                                            itm?.type?.toLowerCase() ===
                                              "administered"
                                              ? ` /${
                                                  getBatch(
                                                    itm?.stockId,
                                                    itm?.batchId
                                                  )?.packageUom
                                                }`
                                              : ""}
                                          </div>
                                        </td>
                                        <td>
                                          {isSubItem && !showSubPrice ? null : (
                                            <div
                                              className={
                                                isSubItem
                                                  ? ""
                                                  : "fs12 font-bold black"
                                              }
                                            >
                                              Rs{" "}
                                              {Number(
                                                !showSubPrice
                                                  ? reqTotal
                                                  : reqUnitPrice
                                              )?.toFixed(2)}
                                            </div>
                                          )}
                                        </td>
                                        {getTreatmentRecordBasedType(
                                          selectedBill?.paymentDetails
                                        )?.some((li) => li?.discount > 0) ? (
                                          <td>
                                            {isSubItem &&
                                            !showSubPrice ? null : (
                                              <div
                                                className={
                                                  isSubItem
                                                    ? ""
                                                    : "fs12 font-bold black"
                                                }
                                              >
                                                {Number(reqDiscount) > 0
                                                  ? Number(
                                                      reqDiscount
                                                    )?.toFixed(2)
                                                  : "-"}
                                              </div>
                                            )}
                                          </td>
                                        ) : null}
                                        <td>
                                          {isSubItem && !showSubPrice ? null : (
                                            <div
                                              className={
                                                isSubItem
                                                  ? ""
                                                  : "fs12 font-bold black"
                                              }
                                            >
                                              Rs {Number(reqTotal)?.toFixed(2)}
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                            {selectedBill?.showSublineItems &&
                              reorderList(
                                getTreatmentRecordBasedType(
                                  selectedBill?.paymentDetails
                                )
                              )?.filter(
                                (pd) =>
                                  pd?.type?.toLowerCase() === "consumables"
                              )?.length > 0 &&
                              reorderList(
                                getTreatmentRecordBasedType(
                                  selectedBill?.paymentDetails
                                )
                              )
                                ?.filter(
                                  (pd) =>
                                    pd?.type?.toLowerCase() === "consumables"
                                )
                                ?.slice(0, 1)
                                ?.map((itm, i) => {
                                  const reqTotal =
                                    reorderList(
                                      getTreatmentRecordBasedType(
                                        selectedBill?.paymentDetails
                                      )
                                    )
                                      ?.filter(
                                        (pd) =>
                                          pd?.type?.toLowerCase() ===
                                          "consumables"
                                      )
                                      ?.reduce(
                                        (acc, li) => acc + Number(li?.total),
                                        0
                                      ) ?? 0;

                                  const reqUnitPrice =
                                    reorderList(
                                      getTreatmentRecordBasedType(
                                        selectedBill?.paymentDetails
                                      )
                                    )
                                      ?.filter(
                                        (pd) =>
                                          pd?.type?.toLowerCase() ===
                                          "consumables"
                                      )
                                      ?.reduce(
                                        (acc, li) =>
                                          acc +
                                          Number(
                                            Number(
                                              li?.mrpPrice ?? li?.price ?? 0
                                            ) * Number(li?.quantity ?? 1)
                                          ),
                                        0
                                      ) ?? 0;

                                  const reqDiscount =
                                    reorderList(
                                      getTreatmentRecordBasedType(
                                        selectedBill?.paymentDetails
                                      )
                                    )
                                      ?.filter(
                                        (pd) =>
                                          pd?.type?.toLowerCase() ===
                                          "consumables"
                                      )
                                      ?.reduce(
                                        (acc, li) => acc + Number(li?.discount),
                                        0
                                      ) ?? 0;

                                  return (
                                    <>
                                      <tr key={i}>
                                        <td>
                                          <div className="fs12 font-bold black">
                                            -
                                          </div>
                                        </td>
                                        <td>
                                          <div className="fs12 font-bold black">
                                            Medical Consumables
                                          </div>
                                        </td>
                                        <td>
                                          <div className="fs12 font-bold black">
                                            1
                                          </div>
                                        </td>
                                        <td>
                                          {selectedBill?.showSublinePrice ? (
                                            <div className="fs12 font-bold black">
                                              Rs{" "}
                                              {Number(reqUnitPrice)?.toFixed(2)}
                                            </div>
                                          ) : null}
                                        </td>
                                        {getTreatmentRecordBasedType(
                                          selectedBill?.paymentDetails
                                        )?.some((li) => li?.discount > 0) ? (
                                          <td>
                                            <div className="fs12 font-bold black">
                                              {Number(reqDiscount) > 0
                                                ? Number(reqDiscount)?.toFixed(
                                                    2
                                                  )
                                                : "-"}
                                            </div>
                                          </td>
                                        ) : null}
                                        <td>
                                          {selectedBill?.showSublinePrice ? (
                                            <div className="fs12 font-bold black">
                                              Rs {Number(reqTotal)?.toFixed(2)}
                                            </div>
                                          ) : null}
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}

                            <tr>
                              <td colSpan="12">
                                <hr className="thin-line2" />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan="12">
                                <div className="flex-row-between">
                                  <div className="w65Per ali-itm-flx-end">
                                    <div className="flex-column w100Per">
                                      <div className="flex-row-ali-cen mb5">
                                        <div className="txt-semi-bold fs12 black">
                                          Person In Charge:
                                        </div>
                                        <Typography className="font-bold fs12 gray4 ml10">
                                          {clinicDet?.name}
                                        </Typography>
                                      </div>
                                      <div className="flex-row-ali-cen mb5">
                                        <div className="txt-semi-bold fs12 black">
                                          Disclaimer:
                                        </div>
                                        <Typography className="fs12 txt-regular gray-color ml10">
                                          {clinicDet?.disclaimer}
                                        </Typography>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w35Per flex-end pr10">
                                    <div className="flex-column w100Per">
                                      {Number(
                                        getTaxAndSubTotalAndTotalForTreatment(
                                          getTreatmentRecordBasedType(
                                            selectedBill?.paymentDetails
                                          ),
                                          services?.data,
                                          selectedBill?.procedure ?? []
                                        )?.discount
                                      ) > 0 ? (
                                        <div className="flex-row-ali-cen mb5">
                                          <div className="w70Per">
                                            <div className="txtstyle">
                                              Discount
                                            </div>
                                          </div>
                                          <div className="w30Per flex-end">
                                            <div className="txtstyle">
                                              {Number(
                                                getTaxAndSubTotalAndTotalForTreatment(
                                                  getTreatmentRecordBasedType(
                                                    selectedBill?.paymentDetails
                                                  ),
                                                  services?.data,
                                                  selectedBill?.procedure ?? []
                                                )?.discount
                                              ) > 0
                                                ? `Rs ${Number(
                                                    getTaxAndSubTotalAndTotalForTreatment(
                                                      getTreatmentRecordBasedType(
                                                        selectedBill?.paymentDetails
                                                      ),
                                                      services?.data,
                                                      selectedBill?.procedure ??
                                                        []
                                                    )?.discount
                                                  ).toFixed(2)}`
                                                : "-"}
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      <div className="flex-row-ali-cen mv5">
                                        <div className="w60Per">
                                          <div className="txtstyle">
                                            Treatment Subtotal
                                          </div>
                                        </div>
                                        <div className="w40Per flex-end">
                                          <div className="txtstyle">
                                            Rs{" "}
                                            {Number(
                                              (getTaxAndSubTotalAndTotalForTreatment(
                                                getTreatmentRecordBasedType(
                                                  selectedBill?.paymentDetails
                                                ),
                                                services?.data,
                                                selectedBill?.procedure ?? []
                                              )?.subTotal ?? 0) +
                                                (getTaxAndSubTotalAndTotalForTreatment(
                                                  getTreatmentRecordBasedType(
                                                    selectedBill?.paymentDetails
                                                  ),
                                                  services?.data,
                                                  selectedBill?.procedure ?? []
                                                )?.discount ?? 0)
                                            )?.toFixed(2)}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="balancecontainer ph5 mt10">
                                        <div className="flex-row-ali-cen w100Per">
                                          <div className="w60Per">
                                            <div className="txt-semi-bold fs14 blue-color">
                                              Total
                                            </div>
                                          </div>
                                          <div className="w40Per flex-end">
                                            <div className="txt-semi-bold fs14 blue-color">
                                              Rs{" "}
                                              {Number(
                                                getTaxAndSubTotalAndTotalForTreatment(
                                                  getTreatmentRecordBasedType(
                                                    selectedBill?.paymentDetails
                                                  ),
                                                  services?.data,
                                                  selectedBill?.procedure ?? []
                                                )?.subTotal
                                              )?.toFixed(2)}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <div className="mb20" />
                          </tbody>
                        </table>
                        <div className="flex-row mv20 ph10">
                          <img
                            src={require("../../../assets/images/jpg/WoofQrCode.jpeg")}
                            alt=""
                            className="img-h50"
                          />
                          <div className="blu-back wh50 flex-center">
                            <img
                              src={require("../../../assets/images/png/VetInstantLogo.png")}
                              alt=""
                              className="img-h40"
                            />
                          </div>
                          <div className="flex-center">
                            <div className="font-bold fs14 ml20">
                              Scan to download our app
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="page-break" />
              </>
            ) : null}
            {getPharmacyRecordBasedType(selectedBill?.paymentDetails)?.length >
            0 ? (
              <div className="mt30">
                <div className="flex-row-ali-cen mv20">
                  <div className="w30Per">
                    <div className="pl20">
                      <div>
                        {clinicDet?.image ? (
                          <img
                            src={clinicDet?.image}
                            className="img-h75"
                            alt=""
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {clinicDet?.name?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="w40Per flex-center">
                    <div className="font-bold fs18 blue-color">
                      {selectedBill?.type === "Pharmacy" ||
                      selectedBill?.type === "Pet Shop"
                        ? "TAX"
                        : "PHARMACY"}{" "}
                      INVOICE
                    </div>
                  </div>
                  <div className="w30Per flex1-end">
                    <div className="flex-column">
                      <div className="font-bold fs12 blue-color">
                        Business Name:
                      </div>
                      <div className="font-medium blue-color fs12">
                        {clinicDet?.name ?? profile?.name ?? ""}
                      </div>
                      <div className="font-bold fs12 blue-color">
                        Business Address:
                      </div>
                      <div className="header-right-text2">
                        {clinicDet?.address ?? ""}
                      </div>
                      {clinicDet?.pharmacyTaxId?.length > 0 ? (
                        <div className="flex-row-ali-cen">
                          <div className="font-bold fs12 blue-color">
                            {selectedBill?.type === "Pharmacy"
                              ? "PHARMACY"
                              : selectedBill?.type === "Pet Shop"
                              ? "PET SHOP"
                              : "PHARMACY"}{" "}
                            TAX ID:{" "}
                          </div>
                          <div className="header-right-text2 ml3">
                            {selectedBill?.type === "Pet Shop"
                              ? clinicDet?.petShopTaxId
                              : clinicDet?.pharmacyTaxId}{" "}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {clinicDet?.mobile?.length > 0 ? (
                        <div className="flex-row-ali-cen">
                          <div className="font-bold fs12 blue-color">
                            Contact:{" "}
                          </div>
                          <div className="header-right-text2 ml3">
                            {clinicDet?.mobile ?? ""}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <div className="line" />
                <div className="flex-row mt10 ph30">
                  <div className="w60Per">
                    <div className="flex-row-ali-cen">
                      <Typography className="font-bold fs14 gray4">
                        Parent Name
                      </Typography>
                      <div className="txt-semi-bold fs14 black capitalize ml10">
                        {selectedBill?.userName}
                      </div>
                    </div>
                    {selectedBill?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Phone Number
                        </Typography>
                        <div className="txt-semi-bold fs14 black capitalize ml10">
                          {selectedBill?.mobile}
                        </div>
                      </div>
                    ) : null}
                    {selectedBill?.apartmentAddress?.length > 0 ? (
                      <div className="flex-row">
                        <Typography className="font-bold fs14 gray4">
                          Address
                        </Typography>

                        <div className="txt-semi-bold fs14 black capitalize ml10 w50Per flex-row-wrap">
                          {selectedBill?.apartmentAddress}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="flex1-end w40Per">
                    <div className="flex-column">
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Payment Status
                        </Typography>
                        <Typography
                          className={`ml10 fs16 font-bold capitalize ${
                            selectedBill?.status === "paid"
                              ? "green2"
                              : selectedBill?.status === "unpaid"
                              ? "red2"
                              : "orange-color"
                          }`}
                        >
                          {selectedBill?.status === "partiallypaid"
                            ? "Partially Paid"
                            : selectedBill?.status}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Total
                        </Typography>
                        <Typography className="black fs16 font-bold ml10">
                          Rs{" "}
                          {Number(
                            getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                selectedBill?.paymentDetails
                              ),
                              services?.data,
                              lastSummary?.procedures ??
                                selectedBill?.procedure ??
                                []
                            )?.subTotal +
                              getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  selectedBill?.paymentDetails
                                )
                              )?.subTotal
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Amount Paid
                        </Typography>
                        <Typography className="green-color fs16 font-bold ml10">
                          Rs{" "}
                          {Number(selectedBill?.amtPaid) > 0
                            ? Number(selectedBill?.amtPaid)?.toFixed(2)
                            : Number(selectedBill?.amtPaid)}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Balance Due
                        </Typography>
                        <Typography className="yellow-color fs16 font-bold ml10">
                          Rs{" "}
                          {Number(
                            Number(
                              getTaxAndSubTotalAndTotalForTreatment(
                                getTreatmentRecordBasedType(
                                  selectedBill?.paymentDetails
                                ),
                                services?.data,
                                lastSummary?.procedures ??
                                  selectedBill?.procedure ??
                                  []
                              )?.subTotal +
                                getTaxAndSubTotalAndTotal(
                                  getPharmacyRecordBasedType(
                                    selectedBill?.paymentDetails
                                  )
                                )?.subTotal
                            ) -
                              // (
                              Number(selectedBill?.amtPaid ?? 0)
                            //  -
                            // Number(
                            //   getTaxAndSubTotalAndTotalForTreatment(
                            //     getTreatmentRecordBasedType(
                            //       selectedBill?.paymentDetails
                            //     ),
                            //     services?.data,
                            //     lastSummary?.procedures ??
                            //       selectedBill?.procedure ??
                            //       []
                            //   )?.discount +
                            //     getTaxAndSubTotalAndTotal(
                            //       getPharmacyRecordBasedType(
                            //         selectedBill?.paymentDetails
                            //       )
                            //     )?.discount
                            // ) ?? 0)
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lower-container">
                  <div className="box-container">
                    <div className="row-container">
                      <div>
                        <div className="colum-header">Pet Name</div>
                        <div className="colum-data">
                          {selectedBill?.petName}
                        </div>
                      </div>
                      <div>
                        <div className="colum-header">Vet Name</div>
                        <div className="colum-data capitalize">
                          {selectedBill?.doctorId === selectedBill?.clinicId
                            ? ""
                            : "Dr. "}
                          {selectedBill?.doctorName}
                        </div>
                      </div>
                      <div>
                        <div className="colum-header">Invoice Number</div>
                        <div className="colum-data">
                          {selectedBill?.invoiceNumbers ?? ""}
                        </div>
                      </div>
                      <div>
                        <div className="colum-header">Invoice Date</div>
                        <div className="colum-data">
                          {moment(new Date(selectedBill?.createdDate)).format(
                            "DD MMM YYYY"
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="thin-line"></div>

                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>HSN/SAC Code</th>
                          <th>SERVICE / ITEM NAME</th>
                          <th>QTY</th>
                          <th>UNIT PRICE</th>
                          {getPharmacyRecordBasedType(
                            selectedBill?.paymentDetails
                          )?.some((li) => li?.discount > 0) ? (
                            <th>UNIT DISCOUNT (Rs)</th>
                          ) : null}
                          <th>TAX</th>
                          <th>TOTAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getPharmacyRecordBasedType(
                          selectedBill?.paymentDetails
                        )?.length > 0 &&
                          getPharmacyRecordBasedType(
                            selectedBill?.paymentDetails
                          )
                            ?.filter((pd) => pd?.type !== "consultation")
                            ?.map((itm, i) => {
                              let stock = null;
                              if (itm?.batchId) {
                                stock = stocks?.data?.find(
                                  (stc) => stc?.stockId === itm?.stockId
                                );
                              }
                              if (itm?.serviceId) {
                                stock = services?.data?.find(
                                  (ser) => ser?.serviceId === itm?.serviceId
                                );
                              }
                              return (
                                <tr key={i}>
                                  <td>
                                    <div className="fs12 font-bold black">
                                      {stock?.hsnSacCode?.length > 0
                                        ? stock?.hsnSacCode
                                        : "-"}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="fs12 font-bold black">
                                      {itm?.name}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="fs12 font-bold black">
                                      {itm?.quantity}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="fs12 font-bold black">
                                      Rs{" "}
                                      {Number(
                                        itm?.mrpPrice ?? itm?.price
                                      )?.toFixed(2)}
                                    </div>
                                  </td>
                                  {getPharmacyRecordBasedType(
                                    selectedBill?.paymentDetails
                                  )?.some((li) => li?.discount > 0) ? (
                                    <td>
                                      <div className="fs12 font-bold black">
                                        {Number(
                                          itm?.mrpDiscount ?? itm?.discount
                                        ) > 0
                                          ? Number(
                                              itm?.mrpDiscount ?? itm?.discount
                                            )?.toFixed(2)
                                          : "-"}
                                      </div>
                                    </td>
                                  ) : null}
                                  <td>
                                    <div className="fs12 font-bold black">
                                      {clinicDet?.pharmacyTaxId?.length > 0
                                        ? itm?.tax > 0
                                          ? Number(itm?.tax)?.toFixed(2)
                                          : "-"
                                        : "-"}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="fs12 font-bold black">
                                      Rs {Number(itm?.total)?.toFixed(2)}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        <tr>
                          <td colSpan="12">
                            <hr className="thin-line2" />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="12">
                            <div className="flex-row-between">
                              <div className="w65Per ali-itm-flx-end">
                                <div className="flex-column w100Per">
                                  <div className="flex-row-ali-cen mb5">
                                    <div className="txt-semi-bold fs12 black">
                                      Person In Charge:
                                    </div>
                                    <Typography className="font-bold fs12 gray4 ml10">
                                      {clinicDet?.name}
                                    </Typography>
                                  </div>
                                  <div className="flex-row-ali-cen mb5">
                                    <div className="txt-semi-bold fs12 black">
                                      Disclaimer:
                                    </div>
                                    <Typography className="fs12 txt-regular gray-color ml10">
                                      {clinicDet?.disclaimer}
                                    </Typography>
                                  </div>
                                </div>
                              </div>
                              <div className="w35Per flex-end pr10">
                                <div className="flex-column w100Per">
                                  {Number(
                                    getTaxAndSubTotalAndTotal(
                                      getPharmacyRecordBasedType(
                                        selectedBill?.paymentDetails
                                      )
                                    )?.discount
                                  ) > 0 ? (
                                    <div className="flex-row-ali-cen mb5">
                                      <div className="w70Per">
                                        <div className="txtstyle">Discount</div>
                                      </div>
                                      <div className="w30Per flex-end">
                                        <div className="txtstyle">
                                          {Number(
                                            getTaxAndSubTotalAndTotal(
                                              getPharmacyRecordBasedType(
                                                selectedBill?.paymentDetails
                                              )
                                            )?.discount
                                          ) > 0
                                            ? `Rs ${Number(
                                                getTaxAndSubTotalAndTotal(
                                                  getPharmacyRecordBasedType(
                                                    selectedBill?.paymentDetails
                                                  )
                                                )?.discount
                                              ).toFixed(2)}`
                                            : "-"}
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="txtstyle">
                                        {selectedBill?.type === "Pharmacy" ||
                                        selectedBill?.type === "Pet Shop"
                                          ? ""
                                          : "Pharmacy "}
                                        Subtotal
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txtstyle">
                                        Rs{" "}
                                        {Number(
                                          getTaxAndSubTotalAndTotal(
                                            getPharmacyRecordBasedType(
                                              selectedBill?.paymentDetails
                                            )
                                          )?.subTotal -
                                            getTaxAndSubTotalAndTotal(
                                              getPharmacyRecordBasedType(
                                                selectedBill?.paymentDetails
                                              )
                                            )?.tax +
                                            getTaxAndSubTotalAndTotal(
                                              getPharmacyRecordBasedType(
                                                selectedBill?.paymentDetails
                                              )
                                            )?.discount
                                        )?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="txtstyle">
                                        Taxes (CGST)
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txtstyle">
                                        {Number(
                                          getTaxAndSubTotalAndTotal(
                                            getPharmacyRecordBasedType(
                                              selectedBill?.paymentDetails
                                            )
                                          )?.tax
                                        ) /
                                          2 >
                                        0
                                          ? `Rs ${Number(
                                              Number(
                                                getTaxAndSubTotalAndTotal(
                                                  getPharmacyRecordBasedType(
                                                    selectedBill?.paymentDetails
                                                  )
                                                )?.tax
                                              ) / 2
                                            )?.toFixed(2)}`
                                          : "-"}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="txtstyle">
                                        Taxes (SGST)
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txtstyle">
                                        {Number(
                                          getTaxAndSubTotalAndTotal(
                                            getPharmacyRecordBasedType(
                                              selectedBill?.paymentDetails
                                            )
                                          )?.tax
                                        ) /
                                          2 >
                                        0
                                          ? `Rs ${Number(
                                              Number(
                                                getTaxAndSubTotalAndTotal(
                                                  getPharmacyRecordBasedType(
                                                    selectedBill?.paymentDetails
                                                  )
                                                )?.tax
                                              ) / 2
                                            )?.toFixed(2)}`
                                          : "-"}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="balancecontainer ph5 mt10">
                                    <div className="flex-row-ali-cen w100Per">
                                      <div className="w60Per">
                                        <div className="txt-semi-bold fs14 blue-color">
                                          Total
                                        </div>
                                      </div>
                                      <div className="w40Per flex-end">
                                        <div className="txt-semi-bold fs14 blue-color">
                                          Rs{" "}
                                          {Number(
                                            getTaxAndSubTotalAndTotal(
                                              getPharmacyRecordBasedType(
                                                selectedBill?.paymentDetails
                                              )
                                            )?.subTotal
                                          )?.toFixed(2)}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <div className="mb20" />
                      </tbody>
                    </table>
                    <div className="flex-row mv20 ph10">
                      <img
                        src={require("../../../assets/images/jpg/WoofQrCode.jpeg")}
                        alt=""
                        className="img-h50"
                      />
                      <div className="blu-back wh50 flex-center">
                        <img
                          src={require("../../../assets/images/png/VetInstantLogo.png")}
                          alt=""
                          className="img-h40"
                        />
                      </div>
                      <div className="flex-center">
                        <div className="font-bold fs14 ml20">
                          Scan to download our app
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          {getTreatmentRecordBasedType(selectedBill?.paymentDetails)?.length +
            getPharmacyRecordBasedType(selectedBill?.paymentDetails)?.length >
          0 ? null : (
            <div className="no-rec">No records available</div>
          )}

          {getTreatmentRecordBasedType(selectedBill?.paymentDetails)?.length +
            getPharmacyRecordBasedType(selectedBill?.paymentDetails)?.length >
          0 ? (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="back-white"
            >
              <div className="flex-end mv20">
                {posPayId ? (
                  <div className="mr20">
                    <CustomButton
                      text="Pay"
                      onClick={() => {
                        setModalData(selectedBill);
                        setTotalBalanceDue(selectedBill?.balanceDue);
                        if (
                          selectedBill?.advanceAmount &&
                          Number(selectedBill?.advanceAmount) <= 0
                        ) {
                          const filtered = PaymentTypeList.filter(
                            (list) => list?.value !== "advanceAdjustment"
                          );
                          setEnabledPaymentTypes(filtered);
                        } else {
                          setEnabledPaymentTypes(PaymentTypeList);
                        }
                        setPayValues({
                          ...payValues,
                          amount: selectedBill?.balanceDue,
                        });
                        setPayModalVisible(true);
                      }}
                      smallBtn
                    />
                  </div>
                ) : null}

                <div className="mr20">
                  <CustomButton
                    text="Download"
                    onClick={() =>
                      handlePrint(null, () => contentToPrint.current)
                    }
                    smallBtn
                  />
                </div>
              </div>
            </Grid>
          ) : null}
        </div>
      </CustomModal>

      <CustomModal
        open={returnModVsble}
        onClose={onCloseRetMod}
        header=""
        modal
        modalWidth={90}
      >
        <div className="scroll-80vh">
          <div className="return-back">
            <div className="flex-row-ali-cen ph40 mv15">
              <div className="w25Per">
                <Typography className="gray29 fs12 font-medium">
                  Pet Name
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {selectedBill?.petName ?? ""}
                </Typography>
              </div>
              <div className="w25Per">
                <Typography className="gray29 fs12 font-medium">
                  Parent Name
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {selectedBill?.userName ?? ""}
                </Typography>
              </div>
              <div className="w25Per">
                <Typography className="gray29 fs12 font-medium">
                  Invoice number
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {selectedBill?.invoiceNumbers ?? ""}
                </Typography>
              </div>
              <div className="w25Per">
                <Typography className="gray29 fs12 font-medium">
                  Invoice date
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {moment(new Date(selectedBill?.createdDate)).format(
                    "DD MMM YYYY"
                  )}
                </Typography>
              </div>
            </div>
          </div>

          <div className="flex-row-ali-cen mt20 ph10">
            <div className="w25Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Service/Item Name
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Available Qty
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Returning Qty
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Unit Price
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Refundable Taxes
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Refund Total
              </Typography>
            </div>
          </div>
          <div className="blue-hor-split mt5" />
          {returnValue?.list?.map((li, i) => {
            const taxVal = Number(li?.tax) / Number(li?.quantity);
            return (
              <div className="plan-bor mt10 flex-row-ali-cen" key={`${i} li`}>
                <div className="w25Per pr10">
                  <Custom3dotString
                    className="txt-regular fs12 gray30"
                    str={li?.name}
                    length={25}
                  />
                </div>
                <div className="w15Per pr10">
                  <Typography className="txt-regular fs12 gray30">
                    {li?.quantity} Nos
                  </Typography>
                </div>
                <div className="w15Per pr10">
                  <CustomTextField
                    value={li?.returnQuantity}
                    error={!!li?.returnQuantityErr}
                    helperText={li?.returnQuantityErr}
                    fullWidth
                    endIcon
                    inputIcon="Nos"
                    handleChange={(e) =>
                      handleChangeRetQty(e?.target?.value, i)
                    }
                  />
                </div>
                <div className="w15Per pr10">
                  <Typography className="txt-regular fs12 gray30">
                    {li?.mrpPrice} Rs
                  </Typography>
                </div>
                <div className="w15Per pr10">
                  <Typography className="txt-regular fs12 gray30">
                    {Number(taxVal) > 0 ? Number(taxVal)?.toFixed(2) : 0} Rs
                  </Typography>
                </div>
                <div className="w15Per">
                  <Typography className="txt-regular fs12 gray30">
                    {Number(li?.returnQuantity ?? 0) *
                      Number(li?.mrpPrice ?? 0)}{" "}
                    Rs
                  </Typography>
                </div>
              </div>
            );
          })}
          {listNotValid ? (
            <FormHelperText error className="flex-center mt10">
              Enter quantity for atleast one item
            </FormHelperText>
          ) : null}
          <div className="flex-row mt30">
            <div className="w30Per">
              <div className="flex-column">
                <CustomSelect
                  list={RefundTypes}
                  value={returnValue?.refundMethod}
                  handleChange={(e) =>
                    handleChange("refundMethod", e?.target?.value)
                  }
                  select
                  fullWidth
                  label="Refund Method"
                  labelTop
                  name="refundMethod"
                />
                <div className="mt10">
                  <CustomTextField
                    value={returnValue?.remarks}
                    handleChange={(e) =>
                      handleChange("remarks", e?.target?.value)
                    }
                    fullWidth
                    label="Remarks"
                    labelTop
                    name="remarks"
                    multiline
                  />
                </div>
              </div>
            </div>
            <div className="flex1-end">
              <div className="w50Per">
                <div className="flex-column">
                  <div className="flex-row-ali-cen">
                    <div className="w60Per">
                      <Typography className="black23 font-medium fs14">
                        Refund Subtotal
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="black23 font-medium fs14">
                        Rs.{" "}
                        {Number(
                          getRefundValues(returnValue?.list)?.subTotal
                        )?.toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="w60Per">
                      <Typography className="black23 font-medium fs14">
                        Refundable Taxes
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="black23 font-medium fs14">
                        Rs.{" "}
                        {Number(getRefundValues(returnValue?.list)?.tax) > 0
                          ? Number(
                              getRefundValues(returnValue?.list)?.tax
                            )?.toFixed(2)
                          : 0}
                      </Typography>
                    </div>
                  </div>

                  <div className="flex-row-ali-cen ref-ttl mt30">
                    <div className="w60Per">
                      <Typography className="blue-color txt-semi-bold fs14">
                        Refund Total
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="blue-color font-bold fs14">
                        Rs.{" "}
                        {Number(
                          getRefundValues(returnValue?.list)?.total
                        )?.toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Save As Draft"
                smallBtn
                onClick={() => submitReturn("draft")}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="Submit"
                smallBtn
                onClick={() => submitReturn("credit")}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {/* 
  "Payment Mode",
  "Person In Charge", */}
                        {dropFields?.includes(li) ? (
                          <CustomSelect
                            list={
                              li === "Status"
                                ? paymentStatusList
                                : li === "Type"
                                ? paymentTypeList
                                : li === "Invoice Type"
                                ? paymentInvoiceTypeList
                                : li === "Person In Charge"
                                ? getClinicVetList()
                                : li === "Payment Mode"
                                ? getPaymentMethodList()
                                : []
                            }
                            value={filterValues?.values?.[li] ?? []}
                            name={li}
                            handleChange={onFilterValuesChange}
                            label={li}
                            multiSelectSearchCheck={li !== "Person In Charge"}
                            select={li === "Person In Charge"}
                          />
                        ) : li === "Balance Due" ? (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="Min Balance Due"
                                fullWidth
                                name="Min Balance Due"
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.["Min Balance Due"]
                                }
                                type="number"
                                label="Min Balance Due"
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="Max Balance Due"
                                fullWidth
                                name="Max Balance Due"
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.["Max Balance Due"]
                                }
                                type="number"
                                label="Max Balance Due"
                              />
                            </div>
                          </div>
                        ) : (
                          <CustomTextField
                            placeholder={li}
                            fullWidth
                            name={li}
                            handleChange={onFilterValuesChange}
                            value={filterValues?.values?.[li] ?? ""}
                            label={li}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default Payments;
